import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ParticleBackground from "@/components/ParticleBackground";
import AIGrid from "@/components/AIGrid";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t } = useTranslation();

  const sections = [
    {
      title: t("terms.section_1_title"),
      desc: t("terms.section_1_desc"),
    },
    {
      title: t("terms.section_2_title"),
      desc: t("terms.section_2_desc"),
    },
    {
      title: t("terms.section_3_title"),
      desc: t("terms.section_3_desc"),
    },
    {
      title: t("terms.section_4_title"),
      desc: t("terms.section_4_desc"),
    },
    {
      title: t("terms.section_5_title"),
      desc: t("terms.section_5_desc"),
    },
    {
      title: t("terms.section_6_title"),
      desc: t("terms.section_6_desc"),
    },
    {
      title: t("terms.section_7_title"),
      desc: t("terms.section_7_desc"),
    },
    {
      title: t("terms.section_8_title"),
      desc: t("terms.section_8_desc"),
    },
    {
      title: t("terms.section_9_title"),
      desc: t("terms.section_9_desc"),
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background relative overflow-hidden">
      <ParticleBackground />
      <AIGrid />
      <Navigation />

      <main className="flex-grow pt-32 pb-20 relative z-10">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-4">{t("terms.page_title")}</h1>
            <p className="text-muted-foreground text-lg">{t("terms.page_subtitle")}</p>
          </motion.div>

          <Card className="p-8 glass-effect border-primary/30 max-w-4xl mx-auto">
            <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">
              {sections.map((section, index) => (
                <section key={index}>
                  <h2 className="text-xl font-semibold mb-4">{section.title}</h2>
                  <p>{section.desc}</p>
                </section>
              ))}

              <div className="text-xs mt-8 pt-4 border-t border-muted">
                <p>{t("terms.last_updated")}</p>
              </div>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;


